module.exports = __webpack_public_path__ + "static/media/banner3.ea9d395c.jpg";